import fetch from "@/utils/fetch";

let validatingPromotionId = "";
let validatingPromise = null;

const clearPromotionData = () => {
  sessionStorage.removeItem("promotionId");
  sessionStorage.removeItem("saleId");
};

/**
 * URL 中带有 promotionId 时校验推广记录。
 * 同一页面内的多个组件会复用校验请求，避免重复调用接口。
 */
export const getValidPromotionData = async (searchParams) => {
  const promotionIdFromUrl = searchParams.get("promotionId") || "";
  const saleIdFromUrl = searchParams.get("saleId") || "";

  if (!promotionIdFromUrl) {
    return {
      promotionId: sessionStorage.getItem("promotionId") || "",
      saleId: sessionStorage.getItem("saleId") || "",
    };
  }

  sessionStorage.setItem("promotionId", promotionIdFromUrl);
  if (searchParams.has("saleId")) {
    sessionStorage.setItem("saleId", saleIdFromUrl);
  }

  if (
    validatingPromotionId !== promotionIdFromUrl ||
    !validatingPromise
  ) {
    validatingPromotionId = promotionIdFromUrl;
    validatingPromise = fetch(
      "/c-activity-consumer/market-tools/getsalepromotionrecordinfo",
      { params: { promotionId: promotionIdFromUrl } }
    ).then((data) => {
      if (data?.promotionExpired === 1) {
        clearPromotionData();
        return { promotionId: "", saleId: "" };
      }

      return {
        promotionId: promotionIdFromUrl,
        saleId: sessionStorage.getItem("saleId") || "",
      };
    });
  }

  return validatingPromise;
};
